/* Root-local image selection. This component never selects or submits a variant. */
(function () {
  'use strict';
  const storefront = window.BSStorefront;
  if (storefront.productGallery) return;
  storefront.productGallery = { unregister: storefront.lifecycle.register('bs-product-gallery', '[data-bs-product]', function(root) {
    const mainImg = root.querySelector('#mainProductImage');
    if (!mainImg) return;
    const items = Array.from(root.querySelectorAll('.gallery-image-item, .product-img-grid-item'));
    const cleanup = [];
    let disposed = false;
    function listen(target, type, handler) {
      const guarded = event => { if (!disposed && root.isConnected !== false) handler(event); };
      target.addEventListener(type, guarded);
      cleanup.push(() => target.removeEventListener(type, guarded));
    }
    function highlight(selected) {
      items.forEach(item => {
        item.style.border = '2px solid ' + (item === selected ? root.dataset.mediaColor || '#ffffff' : 'transparent');
        item.setAttribute('aria-pressed', String(item === selected));
      });
    }
    function select(item) {
      const image = item && item.querySelector('img');
      if (!image) return;
      const fullSrc = image.dataset.fullSrc || image.src;
      if (!fullSrc) return;
      mainImg.src = fullSrc;
      mainImg.dataset.zoomSrc = image.dataset.zoomSrc || fullSrc;
      mainImg.alt = image.alt || image.getAttribute('alt') || '';
      highlight(item);
      root.dispatchEvent(new CustomEvent('bs:product-media-change', { detail: { mediaId: item.dataset.mediaId, source: fullSrc } }));
    }
    try {
      items.forEach(item => {
        const image = item.querySelector('img');
        const saved = ['role', 'tabindex', 'aria-label', 'aria-pressed'].map(name => [name, item.getAttribute(name)]);
        cleanup.push(() => saved.forEach(([name, value]) => { if (value === null) item.removeAttribute(name); else item.setAttribute(name, value); }));
        item.setAttribute('role', 'button'); item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', (image && (image.alt || image.getAttribute('alt'))) || 'View product image ' + (items.indexOf(item) + 1));
        listen(item, 'click', () => select(item));
        listen(item, 'keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(item); }
        });
      });
      // Preserve Liquid's initial hero. A remount highlights the image currently displayed.
      highlight(items.find(item => {
        const image = item.querySelector('img');
        return image && (image.dataset.fullSrc || image.src) === mainImg.src;
      }));
      listen(root, 'bs:product-variant', event => {
        const detail = event.detail, variant = detail && detail.variant;
        if (!detail || !detail.updateMedia || !variant || !variant.featured_image) return;
        const item = items.find(item => String(item.dataset.mediaId) === String(variant.featured_image.id));
        if (item) select(item);
      });
    } catch (error) { disposed = true; cleanup.splice(0).forEach(remove => remove()); throw error; }
    return function dispose() { disposed = true; cleanup.splice(0).forEach(remove => remove()); items.length = 0; };
  }) };
})();
